import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const NotificationSettings = ({ settings, onChange }) => {
  const notificationTypes = [
    {
      key: 'transactionConfirmations',
      label: 'Transaction Confirmations',
      description: 'Get notified when transactions are confirmed on the blockchain',
      icon: 'CheckCircle'
    },
    {
      key: 'notarizationSuccess',
      label: 'Notarization Success',
      description: 'Receive alerts when notarization processes complete successfully',
      icon: 'Shield'
    },
    {
      key: 'emailAlerts',
      label: 'Email Alerts',
      description: 'Send important notifications to your email address',
      icon: 'Mail'
    },
    {
      key: 'browserNotifications',
      label: 'Browser Notifications',
      description: 'Show desktop notifications in your browser',
      icon: 'Bell'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Notification Preferences */}
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Icon name="Bell" size={18} className="text-primary" />
          <h3 className="text-lg font-medium text-foreground">Notification Preferences</h3>
        </div>
        
        <div className="space-y-4">
          {notificationTypes?.map((notification) => (
            <div key={notification?.key} className="bg-muted rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <Icon name={notification?.icon} size={20} className="text-primary mt-1" />
                <div className="flex-1">
                  <Checkbox
                    checked={settings?.[notification?.key]}
                    onChange={(e) => onChange(notification?.key, e?.target?.checked)}
                    label={notification?.label}
                    description={notification?.description}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Email Configuration */}
      {settings?.emailAlerts && (
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Icon name="Mail" size={18} className="text-primary" />
            <h3 className="text-lg font-medium text-foreground">Email Configuration</h3>
          </div>
          
          <div className="bg-muted rounded-lg p-4">
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Email Address:</span>
                <span className="text-sm font-medium text-foreground">user@example.com</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Frequency:</span>
                <span className="text-sm font-medium text-foreground">Immediate</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Status:</span>
                <div className="flex items-center space-x-1">
                  <Icon name="CheckCircle" size={14} className="text-green-600" />
                  <span className="text-sm font-medium text-green-600">Verified</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Browser Permissions */}
      {settings?.browserNotifications && (
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Icon name="Monitor" size={18} className="text-primary" />
            <h3 className="text-lg font-medium text-foreground">Browser Permissions</h3>
          </div>
          
          <div className="bg-muted rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={16} className="text-primary" />
                <span className="text-sm font-medium text-foreground">Notification Permission</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="CheckCircle" size={14} className="text-green-600" />
                <span className="text-sm text-green-600">Granted</span>
              </div>
            </div>
            <p className="text-xs text-muted-foreground mt-2">
              Browser notifications are enabled for this domain. You can manage this in your browser settings.
            </p>
          </div>
        </div>
      )}

      {/* Notification Summary */}
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Icon name="BarChart" size={18} className="text-primary" />
          <h3 className="text-lg font-medium text-foreground">Notification Summary</h3>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-muted rounded-lg p-4 text-center">
            <Icon name="Bell" size={24} className="text-primary mx-auto mb-2" />
            <p className="text-2xl font-bold text-foreground">247</p>
            <p className="text-xs text-muted-foreground">Total Notifications</p>
          </div>
          <div className="bg-muted rounded-lg p-4 text-center">
            <Icon name="CheckCircle" size={24} className="text-green-600 mx-auto mb-2" />
            <p className="text-2xl font-bold text-foreground">189</p>
            <p className="text-xs text-muted-foreground">Success Alerts</p>
          </div>
          <div className="bg-muted rounded-lg p-4 text-center">
            <Icon name="Mail" size={24} className="text-blue-600 mx-auto mb-2" />
            <p className="text-2xl font-bold text-foreground">58</p>
            <p className="text-xs text-muted-foreground">Email Sent</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;